import { Component, OnInit, ViewChild, AfterViewInit }              from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators }      from '@angular/forms';
import { ErrorStateMatcher }                                        from '@angular/material/core';
import { Router, ActivatedRoute }                                   from '@angular/router';
import { first }                                                    from 'rxjs/operators';

import { CalendarComponent }                                        from 'ng-fullcalendar';
import { Options }                                                  from 'fullcalendar';

import { AlertService, DashboardService }                           from '../_services';
import { Globals }                                                  from '../_helpers';
import { HttpHeaders, HttpClient }                                  from '@angular/common/http';

import { NgxSpinnerService }                                        from 'ngx-spinner';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html'
})


export class DashboardComponent implements OnInit, AfterViewInit {

    @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;

    localData = {};
    loading = false;
    submitted = false;
    returnUrl: string;
    inProgress: number;
    totalBatch: number = 0;
    totalCompBatch:number = 0;
    totalInCompBatch:number = 0;
    calendarOptions: Options;
    msgObj = [];
    startDate;
    endDate;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private dashboardService: DashboardService,
        private alertService: AlertService,
        private spinner: NgxSpinnerService,
        private globals: Globals,
        private http: HttpClient
    ) {}

  	ngOnInit() {
        //var step = this.route.snapshot.paramMap.get("step");
        //var urlStep = JSON.parse(localStorage.getItem('urlStep'));
/*        if(step != urlStep.set)
            this.router.navigateByUrl('/login');*/

        this.localData = JSON.parse(localStorage.getItem('currentUser'));
  	}

    ngAfterViewInit(){
        /* Get Data for rendar callendar and assessor info */
        this.onLoadDashboardData();
    }


    private onLoadDashboardData(){
      this.spinner.show();
      var date = new Date(); 
      var y = date.getFullYear(); 
      var m = date.getMonth();
      var sd = new Date(y, m, 1);
      var ed = new Date(y, m + 1, 0);
      var startDate = sd.getFullYear()  + "-" + (sd.getMonth()+1) + "-" + sd.getDate();
      var endDate = ed.getFullYear()  + "-" + (ed.getMonth()+1) + "-" + ed.getDate(); 

        this.http.get("https://ipinfo.io?1d9de60f2d6b22").subscribe((res:any)=>{
        //this.http.get("//ip-api.com/json").subscribe((res:any)=>{ // for local testing
        var geoipresponse = res;
        if(geoipresponse != undefined)
        {
            localStorage.setItem('geoIPData', JSON.stringify(res));                
        }
      }); 

        this.submitted = true;
        this.dashboardService.getEventData(this.globals.root_url, this.localData['usercode'], this.localData['id'], startDate, endDate)
          .pipe(first())
          .subscribe(
            data => {
                if(data.code == 1000){
                    this.totalBatch = data.totalBatch;
                    this.totalCompBatch = data.totalCompleted;
                    this.totalInCompBatch = data.totalInCompleted;
                    var examIds = data.exam_ids;
                    
                    if(examIds.length > 0){
                        this.inProgress =  examIds.length;
                        localStorage.setItem('examIds', JSON.stringify(examIds));
                    }
                    else{
                        this.inProgress = 0;
                    }
                
                   
                    let msgData = data.assessorMsg;
                    if(msgData.length > 0){
                        for (var i = 0; i < msgData.length; ++i) {
                            //this.msgObj[i] = {id: msgData[i].id_assessor_message, message:msgData[i].message};
                            this.msgObj[i] = {message:msgData[i].msgs};
                        }
                    }

                    this.calendarOptions = {
                        editable: true,
                        eventLimit: false,
                        header: {
                            left: 'title',
                            center: '',
                            right: 'today prev,next'
                        },
                        events: data.events
                    };

                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    
                    this.loading = false;
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }

    public inProgressExam(){
        if(this.inProgress){
            this.router.navigateByUrl('/upload-pic');
          //this.router.navigateByUrl('/exam-list');
        }
    }

    public complatedBatch(){
        this.router.navigateByUrl('/complete-batch');
    }

    public eventClick(calEvent) {
      
        console.log(calEvent);
        console.log(calEvent.event.id);
        console.log(calEvent.event.title);
    }


}
